export function getImportSpecifiers(source: string, moduleName: string) {
	const importSpecifiers = new Map<string, Set<string>>();

	// Naively check if the module specifier is referenced at all in the file before proceeding
	if (!source.includes(`'${moduleName}'`) && !source.includes(`"${moduleName}"`)) {
		return importSpecifiers;
	}

	const importDeclarationRe = new RegExp(
		`import[\\s\r\n]+(?:\\w+[\\s\r\n]*,?[\\s\r\n]*)?{(?<specifiers>[^}]*)}[\\s\r\n]+from[\\s\r\n]*(?:"${moduleName}"|'${moduleName}')`,
		'gm',
	);

	// This only handles a basic syntax to balance speed vs correctness:
	// import { x } from 'moduleName';
	// import { x as y } from 'moduleName';
	for (const importDeclaration of source.matchAll(importDeclarationRe)) {
		if (importDeclaration.groups?.specifiers) {
			const specifiers = importDeclaration.groups.specifiers.split(',');

			for (const specifier of specifiers) {
				if (specifier.trim() === '') {
					// Skip a specifier that occurs from the last trailing ,
					continue;
				}

				const specifierWithImported = specifier.split(' as ').map((s) => s.trim());

				const imported = specifierWithImported[0];

				const local = specifierWithImported[specifierWithImported.length === 1 ? 0 : 1];

				importSpecifiers.set(imported, new Set([...(importSpecifiers.get(imported) ?? []), local]));
			}
		}
	}

	return importSpecifiers;
}

export function lowerFirst(str: string) {
	return str.charAt(0).toLowerCase() + str.slice(1);
}
